<template>
  <div>
    <div id="Chart18" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      charts18_data1: [
        "2021-11-12",
        "2021-11-13",
        "2021-11-14",
        "2021-11-15",
        "2021-11-16",
        "2021-11-17",
        "2021-11-18",
        "2021-11-19",
        "2021-11-20",
        "2021-11-21",
        "2021-11-22",
        "2021-11-23",
        "2021-11-24",
        "2021-11-25",
        "2021-11-26",
        "2021-11-27",
        "2021-11-28",
        "2021-11-29",
        "2021-11-30",
        "2021-12-01",
        "2021-12-02",
        "2021-12-03",
        "2021-12-04",
        "2021-12-05",
        "2021-12-06",
        "2021-12-07",
        "2021-12-08",
        "2021-12-09",
        "2021-12-10",
        "2021-12-11",
        "2021-12-12",
        "2021-12-13",
        "2021-12-14",
        "2021-12-15",
        "2021-12-16",
        "2021-12-17",
        "2021-12-18",
        "2021-12-19",
        "2021-12-20",
        "2021-12-21",
        "2021-12-22",
        "2021-12-23",
        "2021-12-24",
        "2021-12-25",
        "2021-12-26",
        "2021-12-27",
        "2021-12-28",
        "2021-12-29",
        "2021-12-30",
        "2021-12-31",
        "2022-01-01",
        "2022-01-02",
        "2022-01-03",
        "2022-01-04",
        "2022-01-05",
        "2022-01-06",
        "2022-01-07",
        "2022-01-08",
      ],
      charts18_data2: [
        36.27, 33.82, 41.99, -2.38, -44.53, 82.93, 14.35, 52.23, 23.7, 11.72,
        -44.89, 32.84, -34.11, 30.01, 30.21, 92.21, 3.95, 79.49, 96.85, 216.56,
        91.48, 53.66, 60.26, 7.52, 58.85, -65.61, -9.71, -9.97, -17.45, 24.94,
        12.93, 6.62, 30.46, -66.38, 93.35, 47.58, -40.26, 70.18, -5.85, 2.82,
        17.07, 23.35, 38.21, 125.76, 87.58, 34.52, -35.74, 11.39, -146.24,
        -124.66, 55.52, -8.17, 4.84, 45.2, 10.05, -37.88, -35.44, 2.83,
      ],
    };
  },
  methods: {
    myEcharts18() {
      var myChart18 = this.$echarts.init(document.getElementById("Chart18"));
      //配置图表
      var option18 = {
        title: {
          show: false,
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 35,
          top: 30,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (params) {
            if(params[0].value > 0){
              return `${params[0].axisValue}<br />净流入金额: ${params[0].value}`
            }else {
              return `${params[0].axisValue}<br />净流出金额: ${params[0].value}`
            }
          },
          
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        xAxis: {
          data: this.charts18_data1,
          silent: true,
          splitLine: {
            show: false,
          },
          splitArea: {
            show: false,
          },
          axisLabel: {
            interval: 8,
            formatter: function (value) {
              //value 为 data的每一项
              //这里会循环 data  return出的每一项会替换渲染对应的data
              return `{a|${value}}`;
            },
            rich: {
              //富文本样式设置
              a: {
                color: "#666",
              },
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#f7f7f7",
            },
          },
          offset: 25,
        },
        yAxis: {
          type: "value",
          //   data:[-100,0,100,200],
          splitArea: {
            show: false,
          },
          axisTick: {
            show: false,
            interval: 1,
          },
        },
        series: [
          {
            type: "bar",
            data: this.charts18_data2,
            large: true,
            barWidth: 12,
          },
        ],
      };
      myChart18.setOption(option18);
    },
    init_chart2_data2() {
      this.charts18_data2 = this.charts18_data2.map((ele) => {
        if (ele > 0) {
          ele = {
            value: ele,
            itemStyle: {
              color: "#fd4c4c",
            },
          };
        } else {
          ele = {
            value: ele,
            itemStyle: {
              color: "#3cbb73",
            },
          };
        }
        return ele;
      });
    },
  },
  mounted() {
    this.init_chart2_data2();
    this.myEcharts18();
  },
};
</script>

<style scoped>
</style>